import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ArrowRight } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Inicio',
    path: '/'
  }, {
    name: 'Servicios',
    path: '/',
    section: 'services'
  }, {
    name: 'Obras',
    path: '/proyectos'
  }, {
    name: 'Quiénes Somos',
    path: '/quienes-somos'
  }];
  const handleNavClick = (e: React.MouseEvent, link: (typeof navLinks)[0]) => {
    e.preventDefault();
    // If has section and we're on home page, scroll to section
    if (link.section && location.pathname === '/') {
      const element = document.getElementById(link.section);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    // If has section but we're NOT on home page, navigate to home then scroll
    else if (link.section && location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(link.section);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
    // Otherwise just navigate normally
    else {
      navigate(link.path);
    }
    setIsMobileMenuOpen(false);
  };
  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('contact');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-md ${isScrolled ? 'shadow-lg py-4' : 'py-6'}`} data-id="element-396">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-397">
        <div className="flex items-center justify-between" data-id="element-398">
          {/* Logo */}
          <Link to="/" className="text-2xl font-black tracking-tighter text-blue-900 hover:text-blue-700 transition-colors" data-id="element-399">
            FORAX<span className="text-blue-600" data-id="element-400">.</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-401">
            {navLinks.map(link => <a key={link.name} href={link.path} onClick={e => handleNavClick(e, link)} className={`text-sm font-medium transition-colors hover:text-blue-600 cursor-pointer ${location.pathname === link.path ? 'text-blue-600' : 'text-gray-700'}`} data-id="element-402">
                {link.name}
              </a>)}
            <a href="/#contact" onClick={handleContactClick} className="group inline-flex items-center gap-2 rounded-full bg-blue-600 px-5 py-2.5 text-sm font-bold text-white transition-all hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-600/20 cursor-pointer" data-id="element-403">
              Conversemos
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-404" />
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-800 hover:text-blue-600 transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-405">
            {isMobileMenuOpen ? <X data-id="element-406" /> : <Menu data-id="element-407" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-408">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-409">
            <div className="px-4 py-6 space-y-4" data-id="element-410">
              {navLinks.map(link => <a key={link.name} href={link.path} onClick={e => handleNavClick(e, link)} className={`block text-lg font-medium transition-colors cursor-pointer ${location.pathname === link.path ? 'text-blue-600' : 'text-gray-900'}`} data-id="element-411">
                  {link.name}
                </a>)}
              <a href="/#contact" onClick={handleContactClick} className="block w-full text-center rounded-xl bg-blue-600 px-5 py-3 text-base font-bold text-white hover:bg-blue-700 transition-colors cursor-pointer" data-id="element-412">
                Conversemos
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}